import { render, staticRenderFns } from "./QuickMessage.vue?vue&type=template&id=bcc77e94&scoped=true"
import script from "./QuickMessage.vue?vue&type=script&lang=js"
export * from "./QuickMessage.vue?vue&type=script&lang=js"
import style0 from "./QuickMessage.vue?vue&type=style&index=0&id=bcc77e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc77e94",
  null
  
)

export default component.exports